// extracted by mini-css-extract-plugin
module.exports = {"desktop":"(min-width: 1024px)","container":"orgServicesPage_container__2Ayzt"};